import { getFromLocalStorage, storeInLocalStorage } from '@/utils/functions/helperFunctions';

const parseStoredJson = (value: string | null) => {
  if (!value || value === 'undefined' || value === 'null') return null;
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};

/**
 * Gets currently selected organization
 * @returns Current organization's ID
 */
export const getCurrentOrganization = () => {
  return parseStoredJson(getFromLocalStorage('current_organization'));
};

/**
 * Sets currently selected organization
 * @returns
 */
export const setCurrentOrganization = (currentOrganization: any) => {
  if (!currentOrganization) {
    localStorage.removeItem('current_organization');
    return;
  }
  return storeInLocalStorage('current_organization', currentOrganization);
};

/**
 * Gets all organizations associated with the user
 * @returns List of organizations
 */
export const getAllOrganizations = () => {
  return parseStoredJson(getFromLocalStorage('organizations'));
};

/**
 * Sets all organizations associated with the user
 * @returns
 */
export const setAllOrganizations = (organizationsList: any) => {
  if (!organizationsList?.length) {
    localStorage.removeItem('organizations');
    return;
  }
  const filteredOrganizations = organizationsList.filter((org: any) => org?.rbac[0]);
  return storeInLocalStorage('organizations', filteredOrganizations);
};

/**
 * Removes organization related information of user from local storage
 */
export function removeOrganizationData() {
  localStorage.removeItem('current_organization')
  localStorage.removeItem('organizations')
}